import React from "react";
import { FooterContainer } from "../../services/footer";
import { Typography, Box, Stack } from "@mui/material";
import { footerList } from "../../constants/footerData";
import { images } from "../../assets/images";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <FooterContainer>
      <Box className="footer_top">
        <Box className="footer_logo_img">
          <a href="/">
            <img
              className="footer_logo"
              src={images.bodyMapper_green_logo}
              alt="BodyMappr"
            />
          </a>
        </Box>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={{ xs: 1, sm: 2, md: 4 }}
          className="footer_list"
        >
          {footerList.map((item) => (
            <Box className="footer_list_box" key={item.id}>
              <Typography className="list_title">{item.title}</Typography>

              {item.title === "Get In Touch"
                ? item.list.map((listItem, idx) => (
                    <Box
                      key={idx}
                      sx={{ display: "flex", alignItems: "flex-start", mb: 1 }}
                    >
                      {listItem.icon}
                      <Box sx={{ ml: 1 }}>
                        {Array.isArray(listItem.text) ? (
                          listItem.text.map((line, i) => (
                            <Typography key={i} className="list">
                              {line}
                            </Typography>
                          ))
                        ) : listItem.type === "email" ? (
                          <a
                            href={`mailto:${listItem.text}`}
                            style={{ textDecoration: "none", color: "#00672F" }}
                          >
                            <Typography className="list">
                              {listItem.text}
                            </Typography>
                          </a>
                        ) : (
                          <Typography className="list">
                            {listItem.text}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  ))
                : item.list.map((listItem, index) => (
                    <Link
                      key={index}
                      to={`/${listItem.toLowerCase().replace(/\s+/g, "-")}`}
                      style={{ textDecoration: "none" }}
                    >
                      <Typography className="list" sx={{ cursor: "pointer" }}>
                        {listItem}
                      </Typography>
                    </Link>
                  ))}
            </Box>
          ))}
        </Stack>
      </Box>

      <Box className="footer_bottom">
        <Typography className="reserved_title">
          Made With Love By BodyMappr. All Rights Reserved.
        </Typography>
      </Box>
    </FooterContainer>
  );
};

export default Footer;
